import { useTranslation } from 'react-i18next';

import { Text } from 'components/LoginComponents';
import RetrySearchForm from 'components/RetrySearchForm';
import { Body, Dialog, Header, Content } from 'components/Modal';
import { GlobalConfig } from 'interfaces/GlobalConfig.interface';
import { CustomText } from 'components/CustomText';
import FocusManager from 'components/FocusManager';
import { useFocus } from 'contexts/FocusContext';

interface NoInfoUpdateModalProps {
  globalConfig: GlobalConfig;
}

const NoInfoUpdateModal = ({
  globalConfig,
}: NoInfoUpdateModalProps): JSX.Element => {
  const { t } = useTranslation();
  const { shouldFocus } = useFocus();

  const configs = globalConfig.config;
  const { noInfoUpdate } = configs;
  const title = noInfoUpdate.title || t('NO_INFORMATION_AVAILABLE');
  const description =
    noInfoUpdate.messageNoUpdate || t('NO_INFO_UPDATE_MESSAGE');
  const { messageSearchForm, isShownSearchForm } = noInfoUpdate;

  return (
    <FocusManager shouldFocus={shouldFocus}>
      <Dialog>
        <Header>
          <CustomText as="span" text={title} />
        </Header>
        <Body>
          <Content>
            <CustomText as={Text} text={description} />
            {isShownSearchForm && (
              <RetrySearchForm messageSearchForm={messageSearchForm} />
            )}
          </Content>
        </Body>
      </Dialog>
    </FocusManager>
  );
};

export default NoInfoUpdateModal;
